var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 0.125C10.1693 0.125 9.49898 0.795312 9.49898 1.625V2.525C6.07711 3.21875 3.49898 6.24687 3.49898 9.875V10.7563C3.49898 12.9594 2.68804 15.0875 1.22554 16.7375L0.878668 17.1266C0.484918 17.5672 0.391168 18.2 0.630231 18.7391C0.869293 19.2781 1.40836 19.625 1.99898 19.625H19.999C20.5896 19.625 21.124 19.2781 21.3677 18.7391C21.6115 18.2 21.513 17.5672 21.1193 17.1266L20.7724 16.7375C19.3099 15.0875 18.499 12.9641 18.499 10.7563V9.875C18.499 6.24687 15.9209 3.21875 12.499 2.525V1.625C12.499 0.795312 11.8287 0.125 10.999 0.125ZM13.1224 23.2484C13.6849 22.6859 13.999 21.9219 13.999 21.125H10.999H7.99898C7.99898 21.9219 8.31304 22.6859 8.87554 23.2484C9.43804 23.8109 10.2021 24.125 10.999 24.125C11.7959 24.125 12.5599 23.8109 13.1224 23.2484Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSolid);
export default __webpack_public_path__ + "static/media/bell-solid.cfa7536568b57cc5ccc04de981d48c23.svg";
export { ForwardRef as ReactComponent };